module.exports = __webpack_public_path__ + "media/images/riders/small/IRINA_KALENTYEVA-17f1fb1a9a598ab6d7e720bc14f154a0.png";